export default {
    // 阿拉伯语
    LOCALE_HTML: {
        'msg.language': '阿拉伯语',
        'msg.title': 'العنوان',
        'msg.type': 'فئة السؤال',
        'msg.des': 'وصف المشكلة',
        'msg.phone': 'رقم الهاتف',
        'msg.regionCode': 'رمز المنطقة',
        'msg.email': 'البريد الإلكتروني',
        'msg.choose': 'حدد وظيفة إرسال الرسالة',
        'msg.detail': 'الرسالة',
        'msg.back': 'الرجوع',
        'your.msg': 'سجل الرسائل',
        'msg.record': 'يرجى إرسال الرسالة',
        'msg.success': 'تم إرسال الرسالة بنجاح',
        'to.record': 'الإنتقال إلى سجل الرسائل',
        completed: 'الإنتهاء',
        submit: 'تقديم',
        'success.desc': 'تم إرسال رسالتك بنجاح، شكرا على بلاغك',
        'msg.form.input': 'يرجى الإدخال',
        'msg.reply': 'الرد',
        'comment.suc': 'شكرا على تقييمك!',
        'comment.fail': 'فشل التقديم',
        'comment.placeholder': 'مرحبا بتقديم الإقتراحات لخدمة العملاء',
        'reply.suc': 'تم التقدييم بنجاح!',
        'reply.fail': 'الرجاء إدخال ردك',
        'reply.placeholder': 'الرجاء إدخال ردك',
        'msg.more': 'المزيد',
        'msg.collapse': 'إخفاء',
        'msg.myservice': 'تقييم خدمتي',
        'msg.evaluate': 'تقييم الخدمة',
        'msg.evaluateTitle': 'تقييم الخدمة',
        'msg.score': 'النتيجة:',
        'msg.remark': 'تعليقات:',
        'msg.status.created': 'تم إنشاء',
        'msg.status.pending': 'في الإنتظار',
        'msg.status.processing': 'جاري ...',
        'msg.status.solved': 'تم الإنتهاء',
        'msg.service.reply': 'رد خدمة العملاء',
        'msg.my.reply': 'ردك',
        'msg.toast.des': 'وصف المشكلة فارغ',
        'msg.toast.type': 'فئة المشكلة فارغ',
        'msg.toast.title': 'العنوان فارغ',
        'msg.toast.none': 'لا يمكن أن يكون فارغ',
        'msg.toast.noAnnex': 'يرجى تحميل المرفق',
        'msg.toast.noEmail': 'لا يمكن أن يكون البريد الإلكتبوني فارغ',
        'msg.toast.noTel': 'لا يمكن أن يكون رقم الهاتف فارغ',
        'msg.toast.noRegionCode': 'لا يمكن أن يكون رمز المنطقة فارغًا',
        'msg.toast.noZone': 'الرجاء تحديد منطقة زمنية',
        'msg.toast.noDateTime': 'الرجاء تحديد التاريخ والوقت',
        'msg.toast.email': 'يرجى إدخل البريد الإلكتروني بالشكل الصحيح',
        'msg.toast.tel': 'يرجى إدخل البريد الإلكتروني بالشكل الصحيح',
        'msg.toast.regionCode': 'الرجاء تحديد رمز المنطقة',
        'msg.toast.num': 'يرجى الأرقام بالشكل الصحيح',
        'msg.toast.annex': 'يرجى تحميل المرفق',
        'msg.toast.char': 'يرجى إدخل الحروف بالشكل الصحيح',
        'msg.list.none': 'لا توجد بيانات',
        'msg.form.choose': 'يرجى الإختيار',
        'msg.form.chooseZone': 'اختر المجال الزمني',
        'msg.form.chooseTime': 'اختيار الوقت',
        'msg.form.chooseDate': 'اختيار التاريخ',
        'msg.form.sure': 'تأكيد',
        'msg.form.search': 'البحث...',
        'msg.form.uploadError': 'المرفق المحمل لا يفي بالمتطلبات',
        'msg.update.time': 'تحديث في',
        'msg.replace.images': 'صورة',
        'file.size.limit': 'مساحة الملف لا يمكن إن تتجاوز 50MB',
        'detail.file.limit': 'كحد أقصى 15 ملفات، لا تتجاوز 50M',
        'form.question.des.tip': 'يرجى إدخال وصف المشكلة',
        'form.title.tip': 'يرجى إدخال العنوان',
        'form.class.tip': 'يرجى إختيار الفئة',
        'upload.file': 'تحميل الملف',
        'file.count.limit': 'كحد أقصى يمكن تحميل 15 ملفات',
        'select.search.placeholder': 'البحث عن كلمة',
        'msg.form.sizeError1': 'يرجى تحميل ملف بمساحة أفل من 5M',
        'msg.form.sizeError2': 'يرجى تحميل ملف بمساحة أفل من 50M',
        'msg.form.submit': 'جاري التقديم...',
        'msg.form.upload': 'جاري التحميل...',
        'msg.email.tip1': 'لم يتم العثور على رسالتك',
        'msg.email.tip2':
            'إذا قد تركت رسالة من قبل، فيمكنك التحقق منها من خلال البريد الإلكتروني',
        'msg.email.tip3': 'التحقق عن طريق البريد الإلكتروني',
        'msg.email.noData': 'لا توجد بيانات لهذا الحساب',
        'email.verify.tip':
            'أدخل البريد الإلكتروني لإستخدامة عند إرسال الرسالة',
        'email.input.placeholder': 'يرجى إدخال البريد الإلكتروني',
        'email.submit': 'الإرسال للبريد الإلكتروني',
        'email.rules.error': 'الرجاء إدخال البريد الإلكتروني الصحيح',
        'email.code.tip':
            'تم الإرسال رمز التحقق للبريد الإلكتروني، يجرى إدخل رمز التحقق',
        'email.code.placeholder': 'يجرى إدخل رمز التحقق',
        'email.code.submit': 'المعاينة',
        'email.notFind.customer': 'لم يتم العصور على معلومات المستخدم',
        'email.code.wrong': 'رمز التحقق غير صحيح، يرجى الإدخال من جديد',
        'email.code.expired':
            'إنتهت صلاحية رمز التحقق، يرجى الإرسال للبريد الإلكتروني مرة أخرى',
        'email.code': 'رمز التحقق',
        'email.send.frequently': 'العملية متكررة للغاية، يرجى المحاولة لاحقاً',
        'comment.fail.400133': 'تم تصنيف هذه التذكرة',
        MSG016: 'تم حلها',
        MSG017: 'غير محلول',
        MSG019: 'يُقدِّم',
        MSG072: 'لا يمكن ترك تسمية التقييم فارغة! ',
        MSG073: 'لغة التقييم لا يمكن أن تكون فارغة! ',
        MSG074: 'ملصق:',
        MSG075: 'هل تم الحل :',
        MSG076: 'الرجاء تحديد ما إذا كان قد تم حل المشكلة',
        MSG015: 'هل هذه التذكرة حلت مشكلتك؟',
        'not.get.user.info': 'غير قادر على الحصول على المعلومات الخاصة بك',
        'user.verify.tip':
            'تحتاج إلى التحقق من صحة قبل أن تتمكن من عرض قائمة الرسائل',
        'verify.type.email': 'التحقق من البريد',
        'verify.text': 'التحقق',
        'cancel.text': 'ألغى',
        'get.verify.code': 'الحصول على رمز التحقق',
        'reGet.verify.code': 'استعادة ',
        'verify.by.email.tip':
            'رمز التحقق سيتم إرسالها عن طريق البريد إلى حساب البريد الإلكتروني الذي أدخلته',
        'verify.type.phone': 'التحقق من الرسائل القصيرة',
        'phone.placeholder': 'الرجاء إدخال رقم الهاتف',
        'verify.by.phone.tip':
            'رمز التحقق سيتم إرسالها عن طريق الرسائل القصيرة إلى رقم الهاتف الذي أدخلته',
        'phone.error': 'الرجاء إدخال رقم الهاتف الصحيح',
        'phone.errorCode400150': 'إرسال رمز التحقق في كثير من الأحيان',
        'phone.errorCode400233': 'الرسائل القصيرة قالب لا يمكن فارغة',
        'phone.errorCode400234': 'عدم كفاية رصيد الرسائل القصيرة والتسويق',
        'phone.errorCode400235': 'إشعار قصيرة الرصيد غير كافية',
        'phone.errorCode400247': 'رسالة خطأ في تكوين وظيفة البرنامج المساعد',
        'phone.errorCode4400248': 'فشل في الحصول على رسالة قصيرة قالب',
        'phone.errorCode400249': 'هذا الرقم ليس رقم هاتف المستخدم الحالي',
        'phone.errorCode400250': 'رمز التحقق منتهية الصلاحية ، يرجى إعادة',
        'msg.you.reply': 'تم الرد عليك',
        'msg.no.reply':'لا يوجد رد',
    },
    LOCALE_REQUEST: {
        400016: 'لقد انتهت صلاحية الحصول على معلومات أمر العمل، يرجى التحديث!'
    },
    LOCALE_SYSTEM: {
        MSG004: ({ name }) => `مرحبا، لقد قامت ${name} بقبول طلبك`,
        MSG012: (color) =>
            `يمكنك <span style="color:${color};text-decoration:underline;" class="js-leave-msg"> إرسال رسالة </span>`,
        MSG013: 'الإرسال لخدمة العملاء'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'يمسح',
                cancel: 'يلغي',
                confirm: 'بالتأكيد',
                inert: 'إدراج',
                width: 'عرض',
                height: 'عالي'
            },
            controls: {
                clear: 'محتوى واضح',
                undo: 'سحب او إبطال',
                redo: 'إعادة',
                fontSize: 'حجم الخط',
                lineHeight: 'ارتفاع خط',
                letterSpacing: 'تباعد الكلمات',
                textIndent: 'مسافة بادئة للفقرة',
                increaseIndent: 'زيادة المسافة البادئة',
                decreaseIndent: 'تقليل المسافة البادئة',
                border: 'إطار',
                color: 'لون',
                textColor: 'لون الخط',
                backgroundColor: 'لون الخلفية',
                tempColors: 'لون مؤقت',
                bold: 'عريض',
                italic: 'مائل',
                underline: 'تسطير',
                strikeThrough: 'يتوسطه خط',
                fontFamily: 'الخط',
                textAlign: 'محاذاة النص',
                alignLeft: 'غادر',
                alignCenter: 'في المركز',
                alignRight: 'يمين',
                alignJustify: 'كلا الطرفين',
                floatLeft: 'تعويم: اليسار',
                floatRight: 'تعويم الحق',
                superScript: 'مرتفع',
                subScript: 'مخطوطة',
                removeStyles: 'أسلوب واضح',
                headings: 'عنوان',
                header: 'عنوان',
                normal: 'عادي',
                orderedList: 'قائمة مرتبة',
                unorderedList: 'قائمة غير مرتبة',
                blockQuote: 'يقتبس',
                code: 'الرمز',
                link: 'وصلة',
                unlink: 'ارتباط واضح',
                hr: 'خط أفقي',
                media: 'وسائط',
                mediaLibirary: 'مكتبة الوسائط',
                emoji: 'تعبير صغير',
                fullscreen: 'تكبير الشاشة',
                exitFullscreen: 'الخروج من الشاشة الكاملة'
            },
            linkEditor: {
                textInputPlaceHolder: 'أدخل نص الارتباط',
                linkInputPlaceHolder: 'أدخل عنوان الارتباط',
                inputWithEnterPlaceHolder:
                    'أدخل عنوان الارتباط واضغط على إدخال',
                openInNewWindow: 'افتح في نافذة جديدة',
                removeLink: 'إزالة الارتباط'
            },
            audioPlayer: {
                title: 'تشغيل ملف صوتي'
            },
            videoPlayer: {
                title: 'تشغيل ملف الفيديو',
                embedTitle: 'الوسائط المضمنة'
            },
            media: {
                image: 'صورة',
                video: 'فيديو',
                audio: 'صوتي',
                embed: 'الوسائط المضمنة'
            }
        },
        finder: {
            remove: 'يمسح',
            cancel: 'يلغي',
            confirm: 'يتأكد',
            insert: 'إدراج العنصر المحدد',
            width: 'عرض',
            height: 'عالي',
            image: 'صورة',
            video: 'فيديو',
            audio: 'صوتي',
            embed: 'الوسائط المضمنة',
            caption: 'مكتبة الوسائط',
            dragTip: 'انقر أو اسحب الملف هنا',
            dropTip: 'حرر للتحميل',
            selectAll: 'اختر الكل',
            deselect: 'إلغاء الاختيار',
            removeSelected: 'حذف العنصر المحدد',
            externalInputPlaceHolder: 'اسم المورد | عنوان المورد',
            externalInputTip: `استخدم "|" للفصل بين اسم المورد وعنوان المورد`,
            addLocalFile: 'أضف الموارد المحلية',
            addExternalSource: 'أضف مورد الويب',
            unnamedItem: 'مشروع بلا عنوان',
            confirmInsert: 'إدراج العنصر المحدد'
        }
    }
}
